// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"47b0d2d7","821":"74a17f8b"}[chunkId] + ".chunk.js";
};